import type { useSingleton } from "@tippyjs/react";
import { TimerIcon } from "@/icons";
import { BottomBarItem } from "@/interface/BottomBar";
import { useTimer } from "@/interface/hooks";
import { Tooltip } from "@/interface/ui/Tooltip";
import styles from "./RightBar.module.scss";

type TimerProps = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
};

export const Timer = ({ singletoneTarget }: TimerProps) => {
    const { timerTime, isTimerRunning, isTimerActive, handleTimerClick } = useTimer();

    return (
        <Tooltip singleton={singletoneTarget} content="Таймер">
            <BottomBarItem active={isTimerActive} onClick={handleTimerClick}>
                <TimerIcon />
                {isTimerRunning && <span className={styles.timerTime}>{timerTime}</span>}
            </BottomBarItem>
        </Tooltip>
    );
};
